var _metadata, _defs, _circle, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBambizzPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "rgb(85, 233, 226)"
    },
    width: 34,
    height: 42,
    viewBox: "0 0 34 42.5",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs12"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,4 V 14071 H 23860 V 4 Z",
    clipRule: "evenodd",
    id: "path26"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.5 -4.25)",
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    className: "a",
    d: "M21,2A17,17,0,0,0,4,18.831C4,30.475,18.981,43.438,19.619,43.99a2.125,2.125,0,0,0,2.763,0C23.125,43.438,38,30.475,38,18.83A17,17,0,0,0,21,2Zm0,23.375a7.438,7.438,0,1,1,7.438-7.437A7.437,7.437,0,0,1,21,25.375Z",
    transform: "translate(4.5 2.25)",
    id: "path4"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 3.188,
    cy: 3.188,
    r: 12,
    fill: "white",
    transform: "translate(22.313 18)",
    id: "circle2"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style41",
    type: "text/css"
  }, "\r\n\t.st0{fill:#ff9e71;}\r\n\t.st1{fill:#A150C7;}\r\n   ")), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "matrix(0.04059344,0,0,-0.04059344,2.4857802,57.449616)",
    style: {
      opacity: 0.93
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "matrix(0.07522845,0,0,0.07522845,-523.45861,348.10325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24",
    clipPath: "url(#clipPath28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 11436.4,6024.61 c -1317,0 -2028.73,163.61 -2028.73,1709.73 v 2756.86 c 0,736.2 523.55,1259.8 1267.93,1259.8 875.4,0 2372.4,106.3 2806,-1096.2 130.9,-368.1 114.5,-809.88 24.5,-1178.01 744.4,-269.95 1038.9,-793.51 1038.9,-1799.72 0,-703.52 -343.5,-1186.17 -1022.5,-1439.77 -629.9,-237.23 -1407.1,-212.69 -2086.1,-212.69 z m -760.8,5161.89 c -327.2,0 -703.47,-179.9 -703.47,-695.3 V 7758.88 c 0,-1096.19 286.27,-1169.82 1464.27,-1169.82 1349.8,0 2544.2,8.19 2544.2,1088.01 0,768.98 -163.6,1071.66 -662.6,1267.99 -237.3,-564.46 -711.7,-1145.28 -1341.6,-1145.28 -728.1,0 -1153.5,768.97 -777.2,1357.97 237.2,351.77 809.9,678.98 1767,482.65 65.4,335.4 57.3,605.4 -16.4,826.2 -278.1,777.2 -1374.3,719.9 -2274.2,719.9 z m 998.1,-2339.61 c -155.5,-245.41 90,-572.64 433.5,-466.29 237.3,65.45 507.2,392.67 662.7,719.89 -392.7,65.44 -899.9,32.72 -1096.2,-253.6 v 0",
    style: {
      fill: "#ff9e71",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBambizzPin);
export default __webpack_public_path__ + "static/media/BambizzPin.f95401a1b209df36908b82473a12b0e3.svg";
export { ForwardRef as ReactComponent };